import { render } from "./QueryByInference.vue?vue&type=template&id=46f55274&ts=true"
import script from "./QueryByInference.vue?vue&type=script&lang=ts"
export * from "./QueryByInference.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__